import { render, staticRenderFns } from "./mobile-booking-details.vue?vue&type=template&id=b45701ca&scoped=true&"
import script from "./mobile-booking-details.vue?vue&type=script&lang=ts&"
export * from "./mobile-booking-details.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-booking-details.vue?vue&type=style&index=0&id=b45701ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45701ca",
  null
  
)

export default component.exports